/* ============================================================
   SWIPE — pure classifier for screen touch gestures (mobile).
   A vertical swipe changes the channel, a horizontal swipe the
   volume; anything below the threshold is a tap (play/pause).
   Kept pure + dependency-free so it's trivially unit-tested.
   ============================================================ */
import type { RemoteAction } from './context'

export type SwipeAction = Extract<RemoteAction, 'chUp' | 'chDown' | 'volUp' | 'volDown'>

export interface SwipeOpts {
  /** minimum travel (px) on the dominant axis to count as a swipe (else it's a tap) */
  threshold?: number
}

/**
 * Classify a touch drag by its delta. The dominant axis wins: vertical → channel (up = chUp),
 * horizontal → volume (right = volUp). Returns null for a tap (neither axis clears the threshold).
 */
export function classifySwipe(dx: number, dy: number, opts: SwipeOpts = {}): SwipeAction | null {
  const threshold = opts.threshold ?? 40
  const ax = Math.abs(dx), ay = Math.abs(dy)
  if (ax < threshold && ay < threshold) return null // a tap
  if (ay >= ax) return dy < 0 ? 'chUp' : 'chDown' // vertical dominant → channel (up = next)
  return dx > 0 ? 'volUp' : 'volDown' // horizontal dominant → volume (right = louder)
}
